import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { toast, Loader } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { useIsClient } from "@grandvisionhq/lib-utils-react";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { validationErrorLabelMap } from "../../../../utils/utils/get-validation-error-codes.js";
import { mapLineItemToDataLayerEvent } from "../../../../mappers/analytics/data-layer/mappers/analytics/data-layer/line-item-to-data-layer-event.js";
import { EmptyCartContainer } from "../../../EmptyCart/containers/modules/EmptyCart/containers/EmptyCartContainer.js";
import { Cart as Cart$1 } from "../../components/modules/Cart/components/Cart.js";
import { useCart } from "../../../../context/Cart/context/Cart/context.js";
import { useCartSettings } from "../../../../context/CartSettings/context/CartSettings/context.js";
const Cart = ({
  donation,
  policyItems,
  selectedPaymentMethodPrice
}) => {
  const { isDynamicLineItemDeliveryEstimationEnabled } = useFeatureToggles();
  const { cart, loading, error } = useCart();
  const settings = useCartSettings();
  const { getLabel, hasLabel } = useIntl();
  const cartExists = Boolean(cart);
  const isClient = useIsClient();
  const { onClick: redirectToHome } = useLink({ route: "home" }) || {};
  const hasDistinctDeliveryEstimationsAlert = Boolean(
    isDynamicLineItemDeliveryEstimationEnabled && hasLabel("cart.alert.distinctDeliveryEstimations.title") && cart?.hasDistinctDeliveryEstimations
  );
  const labels = {
    cartTitle: getLabel("cart.title"),
    alertDistinctDeliveryEstimationsTitle: getLabel("cart.alert.distinctDeliveryEstimations.title"),
    alertDistinctDeliveryEstimationsDescription: hasLabel(
      "cart.alert.distinctDeliveryEstimations.description"
    ) ? getLabel("cart.alert.distinctDeliveryEstimations.description") : void 0,
    unavailableTitle: getLabel("cart.unavailableItems.title")
  };
  React.useEffect(() => {
    if (cart?.validationErrors) {
      const errorCodes = Object.entries(cart.validationErrors).flatMap(([, errorCodes2]) => {
        return errorCodes2.map((code) => validationErrorLabelMap[code]);
      });
      new Set(errorCodes).forEach((code) => {
        toast.failed(`cart.${code}`);
      });
    }
  }, [cart?.validationErrors]);
  const handleCheckoutNavigation = React.useCallback(() => {
    if (!cart?.id || !cart?.lineItems.length) return;
    const dataLayerEvents = mapLineItemToDataLayerEvent(
      DataLayer.DataLayerTypes.EventType.checkout,
      cart?.lineItems || [],
      cart?.id || ""
    );
    dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
  }, [cart?.id, cart?.lineItems]);
  if (!isClient) {
    return null;
  }
  if (loading) {
    return /* @__PURE__ */ React.createElement("div", { className: "cart", "data-t": "loading-cart" }, /* @__PURE__ */ React.createElement(Loader, null));
  }
  const lineItems = cart?.lineItems.filter((lineItem) => !cart?.validationErrors?.[lineItem.id]) || [];
  const unavailableLineItems = cart?.lineItems.filter((lineItem) => cart?.validationErrors?.[lineItem.id]) || [];
  const cartEmpty = lineItems.length < 1 && unavailableLineItems.length < 1;
  const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory(lineItems);
  const visualLineItems = cart?.visualLineItems || [];
  const availableVisualLineItems = visualLineItems.filter((visualLineItem) => {
    return lineItems.some((lineItem) => lineItem.id === visualLineItem.id);
  });
  if (!cartExists || error || cartEmpty) {
    return /* @__PURE__ */ React.createElement(EmptyCartContainer, { onClick: () => redirectToHome?.() });
  }
  return cart ? /* @__PURE__ */ React.createElement(
    Cart$1,
    {
      cartId: cart.id,
      deliveryResolver,
      donation,
      handleCheckoutNavigation,
      hasDistinctDeliveryEstimationsAlert,
      hasSubscription: Boolean(cart?.hasSubscription),
      isReadOnly: settings.isReadOnly,
      labels,
      lineItems,
      policyItems,
      selectedPaymentMethodPrice,
      unavailableLineItems,
      visualLineItems: availableVisualLineItems
    }
  ) : null;
};
export {
  Cart
};
//# sourceMappingURL=Cart.js.map
